import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AcessoService } from './acesso.service';

/**
 * Exige apenas usuário identificado (contexto de acesso presente); sem contexto, redireciona à entrada.
 * Não avalia capacidade de módulo e não autoriza operações no servidor (D10).
 */
export const identificacaoGuard: CanActivateFn = () => {
  const acesso = inject(AcessoService);
  const router = inject(Router);
  if (acesso.obterContexto()) return true;
  acesso.limparContexto();
  return router.createUrlTree(['/acesso']);
};
